<template>
  <div class="desk-frame contact-page">
    <div
      class="head_row_calander bg--white flex flex--content--center no_mobile"
    >
      <h1 class="title title--40 no-marge tx--blue2">
        עדכון מספר רכב לחניון רופאים
      </h1>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <transition name="slide">
      <div class="contact h-main bg--white m-no-bg page-edit-padd">
        <div class="before-send" v-show="!formSent">
          <div class="text center let-1 mb--22">
            רופא/ה יקר/ה באפשרותך לעדכן את מספר הרישוי לשם כניסה אוטומטית לחניון
            הרופאים של בית החולים. פרטי הרישוי יועברו וישמרו במערכת ניהול החניון
            בלבד וניתן יהיה לעדכנם בכל עת.
          </div>

          <ValidationObserver ref="LicensePlateForm">
            <form
              @submit.prevent="sendForm"
              autocomplete="off"
              name="LicensePlateForm"
            >
              <div class="form_input input-38" :class="{ focused: oldNumber }">
                <label>מספר רישוי קודם*</label>
                <validation-provider
                  :rules="{ required: true }"
                  name="oldNumber"
                  v-slot="{ errors }"
                >
                  <input
                    name="oldNumber"
                    v-mask="'#'.repeat(8)"
                    v-model="oldNumber"
                    type="text"
                  />
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
              <div class="form_input input-38" :class="{ focused: newNumber }">
                <label>מספר רישוי חדש*</label>
                <validation-provider
                  :rules="{ required: true }"
                  name="newNumber"
                  v-slot="{ errors }"
                >
                  <input
                    name="newNumber"
                    v-mask="'#'.repeat(8)"
                    v-model="newNumber"
                    type="text"
                  />
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
              <div class="form_submit" :class="{ bt_disable: emptyForm }">
                <input type="submit" value="שליחה" />
              </div>
            </form>
          </ValidationObserver>
          <div class="error-message" v-if="errorMessge">{{ errorMessge }}</div>
        </div>

        <div class="after-send m-center" v-show="formSent">
          <Thank />
          <div class="title tx--blue2">
            תודה, פנייתך נשלחה<br />
            בהצלחה!
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import Thank from "@/assets/img/svg/thank.svg";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import { sendLicensePlateForm } from "../api/api-quatro";

export default {
  name: "LicencePlateForm",
  components: {
    Thank,
    Menu,
    DashboardHeader,
    MenuDesktop
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE"]),
    ...mapState(["activeUser", "activeDoctor"]),
    emptyForm() {
      if (
        this.validatePlateNumber(this.oldNumber) &&
        this.validatePlateNumber(this.newNumber)
      ) {
        return false;
      }
      return true;
    }
  },
  data: () => {
    return {
      loaded: false,
      formSent: false,
      oldNumber: null,
      newNumber: null,
      // REGEX looks for numbers only, between 4 to 8 in length
      plateNumberRegex: new RegExp(/^\d{4,8}$/),
      errorMessge: ""
    };
  },
  methods: {
    ...mapMutations(["UPDATE_MENU_STATE"]),
    sendForm() {
      this.errorMessge = "";
      sendLicensePlateForm(
        this.activeDoctor.name,
        this.activeUser.user_id,
        this.oldNumber,
        this.newNumber
      )
        .then(res => {
          if (res.status == "ERROR") {
            this.errorMessge = res.message;
          } else {
            this.formSent = true;
          }
        })
        .catch(e => {
          if (e.status == "ERROR") {
            this.errorMessge = e.message;
          }
        });
    },
    validatePlateNumber(number) {
      if (this.plateNumberRegex.test(number)) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.loaded = true;
    if (this.MENU_ACTIVE) {
      this.UPDATE_MENU_STATE(false);
    }
  }
};
</script>
